const servepro_route = [
  {
    path: '/servepro',
    name: "servepro",
    component: resolve => {
      require(["@/views/manage/servePro/Index.vue"], resolve);
    },
    redirect: { path: "/servepro/serveproerlist" },
    meta: {
      public: false,
      title: '服务提供者管理',
      navtype: 1,
      active: ['/servepro/serveproerlist', '/servepro/serveproerchecklist']
    },
    children: [
      {
        path: 'serveproerlist',
        name: "serveproerlist",
        component: resolve => {
          require(["@/views/manage/servePro/serveProer/ServeProerList.vue"], resolve);
        },
        meta: {
          public: false,
          title: '服务提供者',
          navtype: 1,
          id: [10025],
          active: ['/servepro/serveproerlist', '/servepro/serveproerchecklist']
        }
      },
      {
        path: 'serveproerinfo',
        name: "serveproerinfo",
        component: resolve => {
          require(["@/views/manage/servePro/serveProer/ServeProerInfo.vue"], resolve);
        },
        meta: {
          public: false,
          title: '查看详情',
          navtype: 1,
          id: [10026],
          active: ['/servepro/serveproerlist', '/servepro/serveproerchecklist']
        }
      },
      {
        path: 'serveProIndex',
        name: "serveProIndex",
        component: resolve => {
          require(["@/views/manage/servePro/serveProer/ServeIndex.vue"], resolve);
        },
        redirect: { path: "/servepro/servepubilsh" },
        meta: {
          title: '发布服务列表',
          navtype: 1,
          active: ['/servepro/serveproerlist', '/servepro/serveproerchecklist']
        },
        children: [
          {
            path: '/servepro/servepubilsh',
            name: "servepubilsh",
            component: resolve => {
              require(["@/views/manage/servePro/serveProer/ServePublish.vue"], resolve);
            },
            meta: {
              public: false,
              id: [10059],
              navtype: 1,
              active: ['/servepro/serveproerlist', '/servepro/serveproerchecklist']
            }
          },
          {
            path: '/servepro/serveinfo',
            name: "serveinfo",
            component: resolve => {
              require(["@/views/manage/servePro/serveProer/ServeInfo.vue"], resolve);
            },
            meta: {
              public: false,
              title: '服务详情',
              id: [10060],
              navtype: 1,
              active: ['/servepro/serveproerlist', '/servepro/serveproerchecklist']
            }
          },
        ]
      },

      // {
      //   path: 'serveproerchecklist',
      //   name: "serveproerchecklist",
      //   component: resolve => {
      //     require(["@/views/manage/servePro/serveProerCheck/ServeProerCheckList.vue"], resolve);
      //   },
      //   meta: {
      //     public: false,
      //     title: '服务提供者审核',
      //     navtype: 1,
      //     id: [10027],
      //     active: ['/servepro/serveproerlist', '/servepro/serveproerchecklist']
      //   }
      // },
      // {
      //   path: 'serveproercheckinfo',
      //   name: "serveproercheckinfo",
      //   component: resolve => {
      //     require(["@/views/manage/servePro/serveProerCheck/ServeProerCheckInfo.vue"], resolve);
      //   },
      //   meta: {
      //     public: false,
      //     title: '查看详情',
      //     navtype: 1,
      //     id: [10028, 10029],
      //     active: ['/servepro/serveproerlist', '/servepro/serveproerchecklist']
      //   }
      // },
      {
        path: '/servepro/serveproindex',
        redirect: { path: "/servepro/serveproerchecklist" },
        name: "serveproerchecklist",
        component: resolve => {
          require(["@/views/manage/servePro/serveProerCheck/index.vue"], resolve);
        },
        meta: {
          public: false,
          title: '服务提供者审核',
          navtype: 1,
          id: [10027],
          active: ['/servepro/serveproerlist', '/servepro/serveproerchecklist']
        },
        children: [
          {
            path: '/servepro/serveproerchecklist',
            name: "serveproerchecklist",
            component: resolve => {
              require(["@/views/manage/servePro/serveProerCheck/ServeProerCheckList.vue"], resolve);
            },
            meta: {
              public: false,
              title: '',
              navtype: 1,
              id: [10027],
              active: ['/servepro/serveproerlist', '/servepro/serveproerchecklist']
            }
          },
          {
            path: '/servepro/serveproercheckinfo',
            name: "serveproercheckinfo",
            component: resolve => {
              require(["@/views/manage/servePro/serveProerCheck/ServeProerCheckInfo.vue"], resolve);
            },
            meta: {
              public: false,
              title: '查看详情',
              navtype: 1,
              id: [10028, 10029],
              active: ['/servepro/serveproerlist', '/servepro/serveproerchecklist']
            }
          },
        ]
      },
    ]
  },
];
export default servepro_route